<template>
    <div :class="containerClasses">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Container',
    props: {
        full: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        containerClasses() {
            const classes = ['mx-auto'];

            if (this.full) {
                classes.push('w-full px-4');
            } else {
                classes.push('container');
            }

            return classes;
        },
    },
};
</script>
